
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skigebiete-in-der-naehe",
      function () {
        return require("private-next-pages/skigebiete-in-der-naehe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skigebiete-in-der-naehe"])
      });
    }
  